import type { Theme } from '../theme';
import type { OverridableComponent, OverridableTypeMap } from '../utils';

export function getBaseCopyToClipboardStyles(theme: Theme) {
  return {
    width: 'fit-content',
    cursor: 'pointer',
    transition: theme.transitions.create(['background-color'], {
      duration: theme.transitions.duration.short,
    }),
    '&:hover': {
      backgroundColor: theme.palette.grey[200],
    },
  };
}

export function isOverridableComponent<T extends OverridableTypeMap>(
  component: unknown,
): component is OverridableComponent<T> {
  return typeof component === 'function' && 'propTypes' in component;
}
